import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_BASIC_DETAILS } from '../queries';
import useProductBasicQueryOptions from './useProductBasicQueryOptions';

const useProductBasicDetails = (
  id,
  slug,
  queryOptions = {},
  hookOptions = {
    skip: false,
  }
) => {
  const options = useProductBasicQueryOptions({
    id,
    slug,
    queryOptions,
    hookOptions,
  });

  const { loading, error, data, refetch } = useSuspenseQuery(
    PRODUCT_BASIC_DETAILS,
    options
  );

  return {
    loading: loading || options.skip || !data,
    error,
    data: data?.basicDetails,
    rawLoading: loading,
    rawData: data,
    refetch,
  };
};

export default useProductBasicDetails;
